import { render, staticRenderFns } from "./gnzx.vue?vue&type=template&id=5a2fc7bc&scoped=true&"
import script from "./gnzx.vue?vue&type=script&lang=js&"
export * from "./gnzx.vue?vue&type=script&lang=js&"
import style0 from "./gnzx.vue?vue&type=style&index=0&id=5a2fc7bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2fc7bc",
  null
  
)

export default component.exports